define("calendar/utils/time-slots", ["exports", "later/utils/time-format", "shared/utils/time-slot-utils"], function (_exports, _timeFormat, _timeSlotUtils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.computeTimeSlotDiffInMins = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/utils/time-format",0,"shared/utils/time-slot-utils"eaimeta@70e063a35619d71f
  const computeTimeSlotDiffInMins = (timeSlotOne, timeSlotTwo) => {
    const week = _timeFormat.convert.days(7).toMinutes();
    const diffInMins = (0, _timeSlotUtils.getMow)(timeSlotOne) - (0, _timeSlotUtils.getMow)(timeSlotTwo);
    if (diffInMins < 0) {
      return -diffInMins;
    }
    if (week / 2 < diffInMins) {
      return week - diffInMins;
    }
    return diffInMins;
  };
  _exports.computeTimeSlotDiffInMins = computeTimeSlotDiffInMins;
});